import { Row, Col, Card } from "react-bootstrap";
import ListPSODirectoryBatchUpdate from "./ListPSODirectoryBatchUpdate";

const PSODirectoryUpdate = () => {
  
  return (
    <Row >
      <Col xl={11} lg={11} md={11} sm={12}>
        
        <Card className="p-4" >
          
          <Card.Body className="text-start">
            
            <h1 id="mainContent" className="text-start mb-3 blue bold header1">PSO Directory Update</h1>
            <br />
            <ListPSODirectoryBatchUpdate></ListPSODirectoryBatchUpdate>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default PSODirectoryUpdate;